function emptyArrayValidator(value = '') {
  let isValid

  const { path, createError } = this

  isValid = value.length > 0

  return (
    isValid ||
    createError({
      path,
      message: 'common::select_value',
    })
  )
}

export default emptyArrayValidator
